<div class="product-label-container" [ngClass]="{'title-is-visible': isTitleVisible()}">
    <bd-fa [name]="'level-up'" [rotate]="90" *ngIf="isArrowVisible()"></bd-fa>
    <div class="text">
        <div class="name" [ngClass]="{'active-hover': activateHover
        && orderItemContainer?.itemToOrder?.images?.[0]}">
            <span (mouseenter)="openInfoPanel(anchor)"
                  (mouseout)="closeInfoPanel()"
                  #anchor>
                {{getItemSKU()}}
            </span>
        </div>
        <div class="description" *ngIf="showTitle">
            {{orderItemContainer?.itemToOrder?.modelTitle}}
        </div>

    </div>
</div>


